'use strict';

module.exports = {
  emailSignupModalPop: function emailSignupModalPop() {
    var _window$UncachedData;
    // Settings come from Data-UncachedData, which common/htmlHead writes into the page
    var emailSignupModalSettings = (_window$UncachedData = window.UncachedData) === null || _window$UncachedData === void 0 ? void 0 : _window$UncachedData.emailSignupModal;
    if ($('#mailingListDetailsModal').length === 0 || !emailSignupModalSettings) {
      return;
    }

    // Data-UncachedData only sees the session's UTM values, so check this page's URL against the same lists
    var query = new URLSearchParams(window.location.search);
    var utmMedium = (query.get('utm_medium') || '').trim().toLowerCase();
    var utmSource = (query.get('utm_source') || '').trim().toLowerCase();
    if (utmMedium && (emailSignupModalSettings.disqualifiedUTMMediums || []).indexOf(utmMedium) > -1 || utmSource && (emailSignupModalSettings.disqualifiedUTMSources || []).indexOf(utmSource) > -1) {
      return;
    }
    if (emailSignupModalSettings.emailAutoPopupEnabled && emailSignupModalSettings.thisPageIsEligible) {
      $('#mailingListDetailsModal').on('show.bs.modal', function () {
        return $.ajax({
          type: 'POST',
          url: emailSignupModalSettings.openAutoModalUrl,
          error: function error(_error) {
            window.console.error('Email Signup Auto Modal Notification Failed', _error);
          }
        });
      });
      var timeDelay = emailSignupModalSettings.emailAutoPopupDelaySeconds * 1000;
      $('#mailingListDetailsModal .modal-body').addClass('d-none');
      $('#mailingListDetailsModal .modal-body.signup-first-step').removeClass('d-none');
      $('#mailingListDetailsModal .modal-title').addClass('d-none');
      $('#mailingListDetailsModal .modal-title.signup-first-step').removeClass('d-none');
      var cancelInterval = false;
      var intervalId = setInterval(function () {
        var searchIsVisible = false;
        var searchElements = document.getElementsByClassName('search-field');
        if (searchElements && searchElements.length > 0) {
          searchIsVisible = searchElements[0].checkVisibility();
        }
        if (searchIsVisible === false) {
          if (cancelInterval === false) {
            $('#mailingListDetailsModal').modal();
            cancelInterval = true;
            clearInterval(intervalId);
          }
        }
      }, timeDelay, cancelInterval, intervalId);
      setTimeout(function () {
        clearInterval(intervalId);
      }, timeDelay * 5);

      // if feature is on, reset form if modal closed without completion, to avoid conflict with footer email signup process
      $('#mailingListDetailsModal').on('hidden.bs.modal', function () {
        $('#mailingListDetailsModal .modal-body').addClass('d-none');
        $('#mailingListDetailsModal .modal-body.signup-details-form').removeClass('d-none');
        $('#mailingListDetailsModal .modal-title').addClass('d-none');
        $('#mailingListDetailsModal .modal-title.signup-details').removeClass('d-none');
      });
    }
    if (emailSignupModalSettings.emailButtonEnabled && emailSignupModalSettings.thisPageIsEligibleForButton) {
      $('.email-signup-button').data('closeButtonUrl', emailSignupModalSettings.closeButtonUrl);
      $('.email-signup-button').show();
    }
  },
  emailModalButton: function emailModalButton() {
    var closeButton = function closeButton() {
      $('.email-signup-button').hide();
      var url = $('.email-signup-button').data('closeButtonUrl');
      if (url) {
        return $.ajax({
          type: 'POST',
          url: url,
          error: function error(_error2) {
            window.console.error('Email Signup Close Failed', _error2);
          }
        });
      }
    };
    $('.email-signup-button-content, .email-signup-button-arrow').click(function () {
      $('#mailingListDetailsModal .modal-body').addClass('d-none');
      $('#mailingListDetailsModal .modal-body.signup-first-step').removeClass('d-none');
      $('#mailingListDetailsModal .modal-title').addClass('d-none');
      $('#mailingListDetailsModal .modal-title.signup-first-step').removeClass('d-none');
      $('#mailingListDetailsModal').modal();
    });
    $('.email-signup-button-close').click(function () {
      closeButton();
    });
    $('#mailingListDetailsModal').on('hide.bs.modal', function () {
      var isModalStep2 = $('#mailingListDetailsModal .modal-body.signup-first-step').hasClass('d-none');
      if (isModalStep2) {
        closeButton();
      }
    });
  }
};